import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'hmi-pano-yukleniyor',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './yukleniyor.component.html',
  styleUrl: './yukleniyor.component.less',
})
export class HmiPanoYukleniyorComponent extends FikoYTKokBilesenComponent {
  constructor() { super(); }
}
